import { useMemo } from 'react';

import { selectors, useAppSelector } from 'state/global-state';

const DEFAULT_REWARD_REDEMPTION_LIMIT = 1;

/**
 * Dynamo-backed cap on the total number of reward applications in the cart
 * (GraphQL `LoyaltyUser.rewardRedemptionLimit`).
 * Enforced as sum(timesApplied) across all applied reward entries, not as a count of distinct
 * cart lines — one cart line with timesApplied:2 counts as 2 toward the limit.
 * Defaults to 1 when the user is absent or the field is missing so legacy/US behavior stays conservative.
 */
export function useRewardRedemptionLimit(): number {
  const { loyaltyUser } = useAppSelector(selectors.loyalty.selectLoyaltyUser);

  return useMemo(
    () =>
      Math.max(
        DEFAULT_REWARD_REDEMPTION_LIMIT,
        loyaltyUser?.rewardRedemptionLimit ?? DEFAULT_REWARD_REDEMPTION_LIMIT
      ),
    [loyaltyUser?.rewardRedemptionLimit]
  );
}
